import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalModule } from '@app/core/global.module';
import { A11yModule } from '@angular/cdk/a11y';
import { SelectService } from './select-service.service';
import { SelectTreeComponent } from './select-tree/select-tree.component';
import { SelectComponent } from './select.component';
import { SelectSearchLoadComponent } from './select-search-load/select-search-load.component';
import { ButtonModule } from '@components/button/modules/button.module';
import { FuiTooltipDirective } from '@fui/fui-components';

@NgModule({
    declarations: [SelectComponent, SelectTreeComponent, SelectSearchLoadComponent],
    providers: [SelectService],
    exports: [SelectComponent],
    imports: [CommonModule, GlobalModule, A11yModule, ButtonModule, FuiTooltipDirective],
})
export class SelectModule {}
